import * as React from 'react';
import get from 'lodash/get';
import styles from './RichNavigation.css';
import NavigationSubMenu from './NavigationSubMenu';
import DropDown, { DropDownPosition } from 'components/DropDownMenu/DropDownMenu';
import TrackableComponent, { ImpressionEvent } from 'components/TrackableComponent/TrackableComponent';
import { Link } from 'react-router';
import omnitureHelper from 'utils/omnitureHelper';
import isEmpty from 'lodash/isEmpty';
import getImageUrl from 'utils/getImageUrl';
import SimpleImage from 'components/Common/Image/SimpleImage';
import { Chevron } from 'components/Icons/Icons';
import shallowEqual from 'utils/shallowEqual';
import { ROOT_LEVEL } from 'constants/RichNavigationConstants';
class NavigationItemWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.getImage = (title, value) => {
            const imageUrl = getImageUrl(get(value, ['image', 'dynamicImageUrl']), '128', '100');
            return (imageUrl && (<div className={styles['image']}>
					<SimpleImage src={imageUrl} alt={title} size={64}/>
				</div>));
        };
        this.setRef = (container) => {
            this.props.innerRef(container);
        };
        this.handleMouseEvent = (isActive) => () => {
            this.setState({
                isActive
            });
        };
        this.state = {
            isActive: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || this.state.isActive !== nextState.isActive;
    }
    render() {
        const { item } = this.props;
        const { isActive } = this.state;
        const data = item.value;
        let url = get(item, ['action', 'url']);
        if (url) {
            url = omnitureHelper.createTrackingUrl(url, item);
        }
        const nodeItems = get(item, 'value.items');
        const nodeLevel = get(item, 'value.levelType');
        const isExpandable = get(item, 'value.isExpandable', false);
        const isLeafNode = isEmpty(nodeItems) && nodeLevel !== ROOT_LEVEL;
        const isRootLeafNode = isEmpty(nodeItems) && nodeLevel === ROOT_LEVEL;
        const fireMouseEvent = !(isLeafNode || isRootLeafNode);
        const mouseHoverEvent = (fireMouseEvent && this.handleMouseEvent(true)) || undefined;
        const mouseLeaveEvent = (fireMouseEvent && this.handleMouseEvent(false)) || undefined;
        const title = get(data, ['text']) || '';
        const content = (<div className={styles['title']}>
				{title}
				{isExpandable ? (<Chevron width={5} height={8} className={styles['chevron']} pathClassName={styles['chevron-path']}/>) : null}
			</div>);
        return (<div ref={this.setRef} className={styles['list-item']} onMouseOver={mouseHoverEvent} onMouseLeave={mouseLeaveEvent} onClick={mouseLeaveEvent}>
				<Link to={isRootLeafNode || isLeafNode ? url : ''}>
					{!this.props.isTextOnly && this.getImage(title, data)}

					{isExpandable ? (<DropDown position={DropDownPosition.CENTER} active={isActive} content={content} className={styles['drop-menu']} tooltipClassName={styles['dropdown-container']} containerClassName={styles['dropdown-inner-container']}>
							{data && <NavigationSubMenu data={data}/>}
						</DropDown>) : (content)}
				</Link>
			</div>);
    }
}
export default TrackableComponent(NavigationItemWrapper, ImpressionEvent.DCI, props => get(props, ['item', 'tracking']));
